
import {GET_ROBOT_LOGS_STARTED} from "../../../reducers/robotReducer";


export const getRobotLogsStarted = () =>{
    return {
        type: GET_ROBOT_LOGS_STARTED,
        payload: {}
    }
}